import React from "react";
import { Instagram, Mail } from "lucide-react";
import { Link } from "react-router-dom";

const IG_URL = "https://www.instagram.com/miguelfaria.photo/";

const Footer = () => {
  return (
    <footer className="bg-black border-t border-white/15" data-testid="main-footer">
      <div className="max-w-[1500px] mx-auto px-6 md:px-12 lg:px-20 py-14 grid grid-cols-1 md:grid-cols-3 gap-10 items-start">
        <div>
          <div className="font-heading text-white text-2xl tracking-[0.25em]">
            MIGUEL FARIA<span className="text-[#c0392b]">.</span>
          </div>
          <p className="text-white/55 text-sm mt-4 max-w-xs leading-relaxed">
            Fotografia desportiva e artística. Portugal — Disponível para projetos nacionais e internacionais.
          </p>
        </div>

        <div className="md:text-center">
          <div className="font-heading text-white tracking-[0.3em] text-xs uppercase mb-4">Seguir</div>
          <div className="flex md:justify-center gap-5">
            <a
              href={IG_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="footer-icon"
              data-testid="footer-instagram"
              aria-label="Instagram"
            >
              <Instagram size={22} />
            </a>
            <a
              href="mailto:geral@miguelfaria.photo"
              className="footer-icon"
              data-testid="footer-email"
              aria-label="Email"
            >
              <Mail size={22} />
            </a>
          </div>
        </div>

        <div className="md:text-right">
          <div className="font-heading text-white tracking-[0.3em] text-xs uppercase mb-4">Acesso</div>
          <Link
            to="/admin/login"
            className="nav-link font-heading tracking-[0.25em] uppercase text-sm"
            data-testid="footer-admin-link"
          >
            Área Reservada
          </Link>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-[1500px] mx-auto px-6 md:px-12 lg:px-20 py-6 flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="text-white/55 text-xs tracking-[0.2em] uppercase font-heading text-center md:text-left">
            © 2026 Miguel Faria Photography — Todos os direitos reservados
          </div>
          <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-xs tracking-[0.2em] uppercase font-heading">
            <Link
              to="/politica-privacidade"
              className="text-white/70 hover:text-[#c0392b] transition-colors"
              data-testid="footer-privacy-link"
            >
              Política de Privacidade
            </Link>
            <Link
              to="/politica-cookies"
              className="text-white/70 hover:text-[#c0392b] transition-colors"
              data-testid="footer-cookies-link"
            >
              Política de Cookies
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
